import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import {
  emailModulesList,
  emailModulesListNext,
  openModal,
} from "../../actions";
import Table from "../../components/Table";
import EmailModuleListItem from "../../components/EmailModuleListItem";
import NonIdealState from "../../components/NonIdealState";
import Pin from "../../components/Pin";
import ListEmailModuleToolbar from "./ListEmailModuleToolbar";
import qs from "qs";

const identity = (data) => data;

export class ListEmailModulePage extends Component {
  constructor(props) {
    super(props);
    this.renderEmail = this.renderEmail.bind(this);
    this.fetchMore = this.fetchMore.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onClone = this.onClone.bind(this);
  }

  componentWillMount() {
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.props.emailModulesList(this.props.match.params.accountId, query, true);
  }

  onDelete(emailId) {
    this.props.openModal("delete-email-module", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  onClone(emailId) {
    this.props.openModal("clone-email-module", {
      id: emailId,
      accountId: this.props.match.params.accountId,
    });
  }

  fetchMore() {
    this.props.emailModulesListNext(this.props.match.params.accountId);
  }

  renderEmail(email) {
    return (
      <EmailModuleListItem
        emailModule={email}
        key={email.id}
        accountId={this.props.match.params.accountId}
        onDelete={this.onDelete}
        onClone={this.onClone}
      />
    );
  }

  renderFetching() {
    return <div>Fetching</div>;
  }

  render() {
    const { emailModules, isFetching } = this.props;
    const query = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    return (
      <div>
        <Helmet>
          <title>{`Mercury - List Email Modules`}</title>
        </Helmet>
        <Pin y={50}>
          <ListEmailModuleToolbar
            accountId={this.props.match.params.accountId}
            searchTerm={query.name}
          />
        </Pin>
        {emailModules.length > 0 ? (
          <Table
            renderItem={this.renderEmail}
            items={emailModules}
            isFetching={isFetching}
            loadMore={this.fetchMore}
            renderFetching={this.renderFetching}
          />
        ) : !isFetching ? (
          <NonIdealState title="No Modules Found" visual="warning" />
        ) : (
          <NonIdealState title="Loading" visual="refresh" spin />
        )}
      </div>
    );
  }
}

ListEmailModulePage.propTypes = {
  emailModulesList: PropTypes.func.isRequired,
  emailModulesListNext: PropTypes.func.isRequired,
  emailModules: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const emailModulesPagination = state.pagination.emailModules || {};
  const emailModules = (emailModulesPagination.ids || [])
    .map((id) => state.entities.emailModule[id])
    .filter(identity);
  const isFetching = emailModulesPagination.isFetching;

  return {
    emailModules,
    isFetching,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  emailModulesList,
  emailModulesListNext,
  openModal,
})(ListEmailModulePage);
